// @flow
import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {SVGAnchor} from "./SVGMarker";
import SVGMarker from "./SVGMarker";
import { images } from "../../../config";
import CurrentRideSelectors from "../../../Store/Ducks/CurrentRide/selectors";
import Markers from "../../../Store/Views/markers";

type ConnectedProps = {
    pickupLat: number,
    pickupLng: number,
    showPickupMarkerSimple: boolean,
    ETADescription: string,
};

class PickupMarkerSimple extends PureComponent<ConnectedProps> {
    render() {
        return (<SVGMarker
            key={"pickupMarkerSimpleSVG"}
            iconPath={images.pickup_marker_icon_simple}
            visible={this.props.showPickupMarkerSimple}
            lat={this.props.pickupLat || 0}
            lng={this.props.pickupLng || 0}
            anchorPosition={SVGAnchor.BOTTOM_CENTER}
        />);
    }
}

const mapStateToProps = (state, props) => {
    return {
        pickupLat: CurrentRideSelectors.getPickupLat(state),
        pickupLng: CurrentRideSelectors.getPickupLng(state),
        showPickupMarkerSimple: Markers.shouldShowPickupMarkerSimple(state),
        ETADescription: CurrentRideSelectors.getETADescription(state),
    };
};

export default connect(mapStateToProps)(PickupMarkerSimple);



// WEBPACK FOOTER //
// ./src/Components/Map/Markers/PickupMarkerSimple.js